/* eslint-disable no-nested-ternary */
import React from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'
import { Modal, Offcanvas, Nav } from 'react-bootstrap'

import useMatchMedia from '~hooks/useMatchMedia'

import HeaderActionLinks from '../../../HeaderActionLinks'

import * as s from './NavModal.module.scss'

const NavModal = (props) => {
  const {
    navMenu,
    primaryText,
    primaryLink,
    secondaryText,
    secondaryLink,
    className,
    isModalOpen,
    onHide,
    isLP,
    ...rest
  } = props

  const isModal = useMatchMedia('(max-width: 767.98px)')

  return React.createElement(
    isModal ? Modal : Offcanvas,
    {
      ...rest,
      show: isModalOpen,
      onHide,
      fullscreen: isModal ? true : null,
      placement: isModal ? null : 'end',
      className: cn('modal-nav-mobile', className),
      backdropClassName: 'modal-nav-mobile-backdrop',
    },
    <Modal.Body id="modal-body-primary">
      <Nav as="ul" variant="header-mobile" className="gap-4">
        {navMenu.map((link) => {
          return (
            <li key={link.id} className="px-6">
              <a
                href={link.to}
                className="text-primary font-medium hover:font-semibold text-2xl"
              >
                {link.text}
              </a>
            </li>
          )
        })}
      </Nav>
      <HeaderActionLinks
        primaryText={primaryText}
        primaryLink={primaryLink}
        secondaryText={secondaryText}
        secondaryLink={secondaryLink}
        variant="mobile"
        className={s.actionLinks}
      />
    </Modal.Body>
  )
}

NavModal.defaultProps = {
  className: undefined,
  onHide: undefined,
  isModalOpen: false,
}

NavModal.propTypes = {
  className: PropTypes.string,
  isModalOpen: PropTypes.bool,
  onHide: PropTypes.func,
}

export default NavModal
